var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5237\u65B0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5237\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.005,1.196 C13.2897711,1.19620312 13.5307729,1.39076535 13.5800666,1.65081143 L13.5900319,1.76579941 L13.5892485,4.73341959 C13.5892485,4.99976479 13.3873666,5.22894477 13.110581,5.27703192 L12.9884062,5.28683916 L9.88646832,5.28618036 C9.56152639,5.28618036 9.30117891,5.03690055 9.30117891,4.73341959 C9.30117891,4.46705054 9.50303571,4.23783652 9.77972933,4.18974685 L9.90186056,4.17993962 L11.7203895,4.18052603 L10.9893488,3.71391188 C10.1930889,3.23959423 9.29614548,2.96455164 8.36683462,2.90916879 L8.02155456,2.89881909 C4.90327013,2.89873952 2.36703203,5.32680321 2.36703203,8.31465068 C2.36703203,11.3024815 4.90333617,13.7306417 8.01620312,13.7306417 C11.1290578,13.7306417 13.6652908,11.3024931 13.6652908,8.31465068 C13.6652908,8.04833428 13.8672104,7.81914827 14.1440312,7.77105866 L14.2662155,7.76125114 L14.3729973,7.77305614 C14.6342841,7.81914626 14.8362031,8.04834535 14.8362031,8.31457087 C14.8362031,11.9085375 11.7781897,14.8362031 8.01620312,14.8362031 C4.25421658,14.8362031 1.19620312,11.9085375 1.19620312,8.31457087 C1.19620312,4.72073011 4.25425198,1.79309825 8.01621797,1.79309825 C9.47880825,1.79324469 10.9012138,2.24491864 12.0722873,3.07931723 L12.4181423,3.33957307 L12.4184196,1.74905514 C12.4184196,1.48266829 12.6203119,1.25344424 12.897042,1.20535148 L13.005,1.196 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#344563",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.4f203151e62aa9e98dc9e75be28c1f16.svg";
export { ForwardRef as ReactComponent };